// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2Zmw9","label":"CategoryService_label__1a59a","location":"CategoryService_location__1VBTm"};